"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apply = apply;
exports.default = void 0;

var _curry = require("../../internal/curry");

function apply(fn, args = []) {
  return fn(...(args === null ? [] : args));
}

var _default = (0, _curry.curry)(apply, 2);

exports.default = _default;